import React from 'react';
import withAuth from "../../../../services/withAuth";
import Header from "../../../../components/Header";
import {Redirect, Prompt} from "react-router-dom";
import PageTitle from "../../../../components/PageTitle";
import moment from "moment/moment";
import MembersApi from "../../../../services/portal-api/MembersApi";
import swal from "sweetalert";
import AuthService from '../../../../services/AuthService';
import NotFound from "../../../NotFound";

class UpdateHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            upactv: [],
            isLoadingMember: true,
            offset : 0,
            limit: 50,
            loadmore: false,
        }
    }

    componentDidMount() {
        MembersApi.getUpdateHistory((result)=>{
            if (result.success) {
                let offset = this.state.limit + this.state.offset;
                let loadmore = result.json.loadMore;
                this.setState({
                    upactv: result.json.data,
                    isLoadingMember : false,
                    offset: offset,
                    loadmore: loadmore,
                });
            } else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingMember: false,
                    });
                    return;
                } else {
                    // alert("Something went wrong.")
                    swal("Something went wrong", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                    
                }
            }           
        },this.props.match.params.id,this.state.offset);
    }

    convertUTCToLocalTime = (dateString) => {
        let date = new Date(dateString);
        const milliseconds = Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds(),
        );
        const localTime = new Date(milliseconds);
        let cd = localTime.getFullYear()+"-"+(localTime.getMonth()+1)+"-"+localTime.getDate()+" "+localTime.getHours()+":"+localTime.getMinutes()+":"+localTime.getSeconds();
        return moment(cd).format('DD/MM/YYYY h:mm A');
    };

    handleLoadMore = (event) => {
        const localTime = new Date();
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let offset = localTime.getTimezoneOffset();
        this.setState({isLoadingMember : true,});
        MembersApi.getUpdateHistory((result)=>{
            if (result.success) {
                let offset = this.state.limit + this.state.offset;
                let loadmore = result.json.loadMore;
                const table_render = this.state.upactv;
                result.json.data.forEach((kmm,index) => {
                            table_render.push(kmm);
                });
                this.setState({
                    upactv: table_render,
                    isLoadingMember : false,
                    offset: offset,
                    loadmore: loadmore,

                });
            }  else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingMember: false,
                    });
                    return;
                } else {
                    // alert("Something went wrong.")
                    swal("Something went wrong", {
                        icon: "warning",
                        buttons: false,
                        timer: 3000
                    });
                }
            }              
        },this.props.match.params.id,this.state.offset,this.state.filterColumn,this.state.filterToken,offset,tz);
    }

    render() {
        const viewUrl = this.props.location.state != undefined ? this.props.location.state.prevPath : "/";
        if (this.state.viewSlug) {
            return (<Redirect to={viewUrl} />);
        }

        let pageTitle = 'Recent Update History';


        const rows = [];let k = 0; const rowstran = [];
        this.state.upactv.forEach((uact,index) => {
            let lt = JSON.parse(uact.changes);let inner_rows=[];
            lt.changes.forEach((rk,yk)=>{
                inner_rows.push(<tr key={yk}>
                 <td style={{backgroundColor:"#f6f6f6",width:"20%"}}><strong>{rk.field}</strong></td>
                 <td style={{backgroundColor:"#f6f6f6",wordBreak:"break-all",width:"40%"}}>{rk.prev}</td>
                 <td style={{backgroundColor:"#f6f6f6",wordBreak:"break-all",width:"40%"}}>{rk.next}</td>
               </tr>)
           });
            rows.push(<tr key={index}>
                <td style={{verticalAlign:"top",backgroundColor:"#fff"}}><table style={{marginTop:"0"}}>
                            {index == 0 && <thead>
                                <tr>
                                    <th style={{width:'15%'}}><strong>Date</strong></th>
                                    <th><strong>User</strong></th>
                                    <th><strong>Store</strong></th>
                                    <th><strong>Admin</strong></th>
                                </tr>
                            </thead>}
                            <tbody>
                                <tr>
                                    <td style={{width:'15%'}}>{this.convertUTCToLocalTime(uact.created_at)}</td>
                                    <td><strong style={{color:'#2170c3'}}>{lt.usrname}</strong></td>
                                    <td>{lt.storename}</td>
                                    <td><strong style={{color: lt.admin == 'Yes'?'green':'red'}}>{lt.admin}</strong></td>
                                </tr>
                            </tbody>
                    </table>
                    </td>
                    <td style={{verticalAlign:"top",backgroundColor:"#fff"}}><table style={{marginTop:"0"}}>
                    {index == 0 && <thead>
                                <tr>
                                    <th><strong>Field Name</strong></th>
                                    <th><strong>Previous Value</strong></th>
                                    <th><strong>Updated Value</strong></th>
                                </tr>
                            </thead>}
                            <tbody>
                              {inner_rows}
                            </tbody>
                    </table>
                </td>
            </tr>
            );
        });

        $(document).ready(function(){
            $('.scrollToTop').hide();
            console.log(window.innerHeight);
                //Check to see if the window is top if not then display button
                $(window).scroll(function(){
                    if ($(this).scrollTop() > 300) {
                        console.log("sd");
                        $('.scrollToTop').show();
                    } else {
                        $('.scrollToTop').hide();
                    }
                });
                
            });
            let loaderOffset = {
                top:200,
                position:'absolute',
                left:'50%',
            }    
            
            if(this.state.offset != 0){
    
                loaderOffset = {
                    bottom:400,
                    position:'absolute',
                    left:'50%',
                }   
            } 
        return(
            AuthService.can('View update history') ?
            <div>
               <Header />
                <main className="content" role="main">
                    <div className="container container--wide padding--60">

                        <header className="header--page clearfix">

                            <PageTitle back={viewUrl} title={pageTitle} />

                        </header>

                        <div className="margin--40--top validate padding--200--bot" >

                        <div className="table--overflow clearfix">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Actor</th>
                                        <th>Detailed changes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows}
                                    {rows.length === 0 &&
                                        <tr>
                                            <td colSpan="2">No results founds.</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            {this.state.loadmore && <button onClick={this.handleLoadMore} style={{position:"relative",left:"50%",bottom:20,marginTop:60,zIndex:9999,padding: '5px 5px 5px',fontSize:12,borderRadius:23,background:"#2170c3",fontWeight:600,color:"white",width:112,boxShadow:'0px 0px 6px #58626c'}}>load more</button>}
                            {this.state.isLoadingMember && <div style={{position: 'absolute',height: '100%',width: '100%',top: 0,background: '#fff',zIndex: 7777,opacity: 0.8}}>
                                <div className="sk-fading-circle" style={loaderOffset}>
                                    <div className="sk-circle1 sk-circle" />
                                    <div className="sk-circle2 sk-circle" />
                                    <div className="sk-circle3 sk-circle" />
                                    <div className="sk-circle4 sk-circle" />
                                    <div className="sk-circle5 sk-circle" />
                                    <div className="sk-circle6 sk-circle" />
                                    <div className="sk-circle7 sk-circle" />
                                    <div className="sk-circle8 sk-circle" />
                                    <div className="sk-circle9 sk-circle" />
                                    <div className="sk-circle10 sk-circle" />
                                    <div className="sk-circle11 sk-circle" />
                                    <div className="sk-circle12 sk-circle" />
                                </div>
                            </div>}
                        </div>

                        </div>
                        

                    </div>
                    <div className="scrollToTop" title="scroll to top" style={{position:"absolute",bottom:30, right: 30,cursor:'pointer', borderRadius:34, boxShadow:'0px 1px 7px #444',width:40,height:40,transform: 'rotateZ(180deg)',padding:8,textAlign:'center'}} onClick={()=>{window.scrollTo({top: 0,behavior: 'smooth',});}}>V</div>
                </main>
            </div>
            : <NotFound forbidden={true} />
        );
    }

}
export default withAuth(UpdateHistory);